import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Admin from "../Dashboard";
import DeleteSchoolModal from "../School/DeleteSchoolModal";
import dayjs from "dayjs";

export default function ConsultationList() {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState({});
  
  // Pagination
  const [page, setPage] = useState(1);
  const limit = 10; // per page
  const [totalPages, setTotalPages] = useState(1);

  // Fetch consultations
  const getConsultations = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get-consultation?page=${page}&limit=${limit}`
      );

      if (response.status === 200) {
        setList(response.data.data);

        setTotalPages(response.data.pagination.pages || 1);
      }
    } catch (error) {
      console.log("Error fetching consultations", error);
    }
  };

  useEffect(() => {
    getConsultations();
  }, [page]);

  // Delete
  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/delete-consultation/${id}`
      );
      if (res.status === 200) {
        setOpen(false);
        getConsultations();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Edit
  const handleEdit = (id) => navigate(`/admin/editConsultation/${id}`);

  // Status Change
  const handleSwitchChange = async (id, currentValue) => {
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}/consultation/status`, {
        id,
        status: !currentValue,
      });
      getConsultations();
    } catch (error) {
      console.log("Error updating status", error);
    }
  };

  const formatCategory = (value) => {
  if (!value) return "-";
  return value
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

  return (
    <Admin>
      <DeleteSchoolModal
        open={open}
        onClose={() => setOpen(false)}
        school={deleteItem.title}
        handleDelete={handleDelete}
        deleteSchoolId={deleteItem.id}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="contained"
          sx={{ bgcolor: "#177D84" }}
          onClick={() => navigate("/admin/addConsultation")}
        >
          Add
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sno</TableCell>
               <TableCell>Title (EN)</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Actions</TableCell>
              {/* <TableCell>Status</TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody>
            {list.map((item, index) => (
              <TableRow key={item._id}>
                <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                <TableCell>{item?.title?.en || "-"}</TableCell>
                <TableCell>{formatCategory(item?.category)}</TableCell>
                <TableCell>
                  {dayjs(item.createdAt).format("DD/MM/YYYY")}
                </TableCell>

                {/* Delete */}
                <TableCell>
                  <IconButton
                    onClick={() => {
                      setDeleteItem({
                        title: item.data?.title?.en,
                        id: item._id,
                      });
                      setOpen(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>

                  {/* Edit */}
                  <IconButton onClick={() => handleEdit(item._id)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>

                {/* Toggle Status */}
                {/* <TableCell>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={item.isShow}
                        onChange={() =>
                          handleSwitchChange(item._id, item.isShow)
                        }
                      />
                    }
                  />
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
        <Button
          variant="outlined"
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Prev
        </Button>
        <Button
          variant="outlined"
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </Button>
      </Box>
    </Admin>
  );
}
